var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgXIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 29 27"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#746366",
  d: "M.701.854 11.409 15.17.633 26.81h2.425l9.434-10.191 7.622 10.191h8.253L17.057 11.69 27.087.854H24.66l-8.688 9.386L8.953.854H.702ZM4.267 2.64h3.791L24.8 25.024h-3.791L4.267 2.64Z"
})));
export { SvgXIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/x-icon.8bed501512aa1192a840.svg";